import React from 'react'

const KnockoutButton = ({ label, style, onClick, color }) => {
	return (
		<div
			style={{ color, ...style }}
			onClick={onClick}
			className="knockout-button"
		>
			{label}
			<style jsx>{`
				.knockout-button {
					padding: 0.3125rem 0.625rem;

					border: 1px solid var(--color-black);
					color: var(--color-black);
					border-radius: 200px;
					margin-bottom: 0.625rem;
					display: inline-block;
					font-family: 'Graphik';
					font-weight: 700;
					font-size: 14px;
					line-height: 14px;
					cursor: pointer;
				}
			`}</style>
		</div>
	)
}

export default KnockoutButton
